export default __webpack_public_path__ + "static/media/rectangleKeto.881067ae.svg";